import React, { useState } from "react";

import { useStoreSearchContext } from "../../storeSearch.context";
import { StoreSearchControlsComponent } from "./storeSearchControls.components";

type StoreSearchControlsProps = {};

export const StoreSearchControls = ({}: StoreSearchControlsProps) => {
    const { selectedSearchItem } = useStoreSearchContext();

    const [filtersOpen, setFiltersOpen] = useState<boolean>(false);

    const toggleFilters = () => setFiltersOpen(open => !open);

    return (
        <StoreSearchControlsComponent
            selectedSearchItem={selectedSearchItem}
            filtersOpen={filtersOpen}
            toggleFilters={toggleFilters}
        />
    );
};
